module.exports = __webpack_public_path__ + "img/quyu2.f0a2766a.png";